// postCharacterImageGeneration.ts
import apiRequest from './apiRequest';

export interface CharacterImageGenerationResponse {
  jobID: string;
  images: Array<{ imageURL: string }>;
}

export type ImageGenerationPayload = {
  filename?: string;
  fileExtension?: string;
  jobID?: string;
  prompt?: string;
};

export async function postCharacterImageGeneration(
  payload: ImageGenerationPayload,
) {
  return await apiRequest<CharacterImageGenerationResponse>(
    'mogen-orchestration',
    `/characters/imageGeneration`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );
}
